import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    $('.datepicker').flatpickr({ dateFormat: "m/d/Y", now: today });
    $('.datepicker-current').flatpickr({ dateFormat: "m/d/Y", now: today, defaultDate: new Date(Date.now() + 5 * 24*60*60*1000) });
    $('.runtime').flatpickr({ enableTime: true, noCalendar: true, dateFormat: "H:i" });
  }
}